var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPendingMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    width: 40,
    height: 40,
    rx: 6,
    fill: "#2CD6F9",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.333 18H10.333M19.333 27H27.133C28.2531 27 28.8132 27 29.241 26.782C29.6173 26.5903 29.9233 26.2843 30.115 25.908C30.333 25.4802 30.333 24.9201 30.333 23.8V16.2C30.333 15.0799 30.333 14.5198 30.115 14.092C29.9233 13.7157 29.6173 13.4097 29.241 13.218C28.8132 13 28.2531 13 27.133 13H25.333M19.333 27L21.333 29M19.333 27L21.333 25M15.333 27H13.533C12.4129 27 11.8528 27 11.425 26.782C11.0487 26.5903 10.7427 26.2843 10.551 25.908C10.333 25.4802 10.333 24.9201 10.333 23.8V16.2C10.333 15.0799 10.333 14.5198 10.551 14.092C10.7427 13.7157 11.0487 13.4097 11.425 13.218C11.8528 13 12.4129 13 13.533 13H21.333M21.333 13L19.333 15M21.333 13L19.333 11",
    stroke: "#2CD6F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingMoney);
export default __webpack_public_path__ + "static/media/pending-money.7bc426764b0639e5dbaa7e5be6eb4e89.svg";
export { ForwardRef as ReactComponent };